<template>
  <div data-color="clear" class="js-header-panel ">
     <div class="c-page c-blog u-pad-x-w3of12 u-pad-x-w1of12@sm u-pad-t-ultra u-pad-t-ultra@sm ">
       <section   data-color="clear"  class="u-pad-t-xxl    js-header-panel is-active "   >
         <div class="c-page__header o-wrapper--panel " :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
      </div>
       </section>
     <section   data-color="clear"      class="u-relative   js-header-panel is-active"  >
      <header class="c-blog__header">
        <h1 class="t-h1 t-text--roman u-marg-b-xs u-color--gray"><router-link  :to="globalContent.nav.links[4].href" class="c__item__link__News3">< Back to News</router-link></h1>
       </header>
       <div class="u-fit inspire-Custom-Container u-marg-x-auto u-marg-y-xs35 u-marg-y-sm@sm">
           <div class="u-fit-w">

                     <div class="t-text--md--bold  u-marg-y-md u-marg-l-sm  u-marg-r-sm t-text--md--bold@md u-relative">
                         <span class="t-h3  c-home__section__upcomingprogram_title" :class="{'u-color--gray-light':post.blocks.color=='dark',' c-inspire-title--color':post.blocks.color!='dark'}" v-html="post.blocks.title" ></span>
                         <span  class="c-line c-line--x u-absolute u-pos-bl u-bg--white u-fit-w"></span>
                       </div>

            </div>
             <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none is-active"></div>
             <div class="c-home__section__fade u-relative u-zindex--3 u-fit-w">
                   <div class="c-team__content  u-marg-t-md  u-w2of2 " >
                       <section class="u-relative">
                         <div class="c-team__section-container u-relative   u-marg-x-sm ">
                             <div class="c-team__section"   v-for="(item, index)  in post.blocks.content">

                                     <div class="u-marg-x-auto "  style="flex-grow:2;"  v-if="item.type.value=='image'">
                                           <img  :src="item.content"  class="img-fluid" >
                                     </div>


                                     <div class="asidewoekshop c-workshop__link__description-container"  >
                                           <!--<h4 class="t-text--sm  u-align-left  c-inspire-pcomingp---boxblue-workshop  u-color--brand-blue u-marg-t-sm " v-if="item.type.value=='title'"  v-html="item.content"></h4>-->
                                           <h4 class="t-text--xs t-text-lh--xl  u-align-left u-color--white  u-pad-b-xl  c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm" v-if="item.type.value=='default'" v-html="item.content" ></h4>
                                           <div class="u-marg-x-auto "  v-for="(itemimgup ,indexc)  in item.contentImgUp"    v-if="item.type.isimageUP=='true'">
                                                 <img  :src="itemimgup.content.src"  class="img-fluid" ><h5 class="u-marg-x-auto u-color--white">{{itemimgup.content.label}}</h5>
                                           </div>
                                           <ul v-if="item.type.isListbullet=='true'" class="u-color--gray" style="list-style-type: square;padding-left:18px;" >
                                             <li  v-for="(itema, indexa)  in item.contentbullet"><h4 class="t-text--xs  u-align-left u-color--white   c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="itema.text" ></h4></li>
                                           </ul>
                                           <ul v-if="item.type.isListnumbers=='true'" class="u-color--gray" style="list-style-type: decimal;padding-left:18px;" >
                                             <li  v-for="(itemb, indexb)  in item.contentnumbers"><h4 class="t-text--xs  u-align-left u-color--white   c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="itemb.text" ></h4></li>
                                           </ul>
                                           <div class="u-marg-x-auto "  v-for="(itemimg ,indexc)  in item.contentImgDown"    v-if="item.type.isimagedown=='true'">
                                                 <img  :src="itemimg.content.src"  class="img-fluid" ><h5 class="u-marg-x-auto u-color--white">{{itemimg.content.label}}</h5>
                                           </div>
                                     </div>


                             </div>
                         </div>
                       </section>
                   </div>
             </div>
               </div>
     </section>

     </div>
     <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>

  </div>
</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'

export default
{
          components:{
                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter,
                                    "app-scroll-object":AppScrollObject


                    },
                    props:
                    {
                        adminContent: {
                            type: Object,
                            default: function() {}
                        },
                        globalContent: {
                            type: Object,
                            default: function() {}
                        },
                        headerPageSize: {
                            type: Array,
                            default: function() {}
                        }
                    },
                  data: function() {
                      return {

                      }
                  },
                  computed:
                  {


                      computedPosts: function()
                      {
                                console.log("this.adminContent.en.news_and_media[1].length"+this.adminContent.en.news_and_media);
                                var t = null,n = this.adminContent.en.news_and_media[1].length;
                                console.log("this.adminContent.en.news_and_media[1].length"+this.adminContent.en.news_and_media[1].length);
                                for (var e = 0;e < n; e += 1)
                                {
                                    var r = this.adminContent.en.news_and_media[1][e];
                                    r.slug === this.$route.params.slug && (t = r)
                                }
                                  console.log(t);
                                return t
                        }//,
                      //computedCurrentPageIndex: function()
                      //{
                          //var t = 1;
                          //return this.$route.query.page && (t = this.adminContent.en.news_and_media[this.$route.query.page] ? parseInt(this.$route.query.page, 10) : 0), t
                      //}
                  },

                  created: function()
                  {
                        this.post = this.computedPosts,
                        console.log("this.post = this.computedPost,"+this.post);
                        //this.post || this.$router.push("/marine-holdings/media-news"),
                        this.onResize = this.onResize.bind(this),

                        this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {

                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                    //document.addEventListener('render-done', (e) => {   console.log(e)})
                    //this.$nextTick(() => {const event = new CustomEvent('render-done');  document.dispatchEvent(event);})
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {

                      onResize: function() {},
                      LinkResource(Linkurl)
                    {
                      window.open('https://www.facebook.com/sharer/sharer.php?u='+Linkurl,'facebook-share-dialog','width=626,height=436'); return false;
                    }
                  }
    }

</script>
<style  scoped>

</style>
